module.exports = __webpack_public_path__ + "media/images/indicators/ipvs-32bf4f486d4a85e99fda0e37e8406c07.png";